import WorkshopsBlock from './WorkshopsBlock';

export default WorkshopsBlock;
